const translations = {
  title: "Billing & Invoices",
  subtitle: "Create invoices, accept payments, print tax bills and receipts.",
  newInvoice: "New Invoice",
  invoiceList: "Invoice List",
  invoiceDetail: "Invoice Detail",
  invoiceNo: "Invoice No.",
  invoiceDate: "Invoice Date",
  invoiceNotFound: "Invoice not found.",
  selectBillingType: "Select Billing Type",
  billingTypeLabel: "Invoice Type",
  // Billing type labels
  type_ready_stock: "Ready Stock Sale",
  type_ready_stock_desc: "Direct sale of pre-manufactured stock items",
  type_custom_order: "Custom Order Delivery",
  type_custom_order_desc: "Delivery of custom manufactured jewellery order",
  type_repair: "Repair Job",
  type_repair_desc: "Billing for repairing or soldering work",
  type_polishing: "Polishing Job",
  type_polishing_desc: "Billing for colouring, polishing or washing items",
  type_wholesale: "Wholesale Bill",
  type_wholesale_desc: "Wholesale transactions with other firms or goldsmiths",
  type_advance: "Advance Deposit",
  type_advance_desc: "Generate advance receipt for booking a design",
  type_outstanding: "Outstanding Receipt",
  type_outstanding_desc: "Receive payment for previous outstanding ledgers",
  type_mfg_bill: "Manufacturing Bill",
  type_mfg_bill_desc: "Karigar gold account — gold given, received, balance",
  // Customer
  customer: "Customer",
  selectCustomer: "Select Customer",
  walkInCustomer: "Walk-In Customer",
  customerName: "Customer Name",
  customerPhone: "Customer Phone",
  customerGstin: "Customer GSTIN",
  newCustomer: "New Customer",
  registerCustomer: "Register Customer",
  // Items
  lineItems: "Line Items",
  addItem: "Add Item",
  itemName: "Item Name / Description",
  category: "Category",
  grossWeight: "Gross Wt (g)",
  netWeight: "Net Wt (g)",
  purity: "Purity",
  fineGold: "Fine Gold (g)",
  goldRate: "Gold Rate (₹/g)",
  makingCharge: "Making (₹)",
  stoneCharge: "Stone / Other (₹)",
  lineTotal: "Line Total",
  removeItem: "Remove Item",
  serviceJob: "Service job",
  // Payment
  payments: "Payments",
  addPayment: "Add Payment",
  paymentMode: "Payment Mode",
  paymentAmount: "Amount (₹)",
  paymentReference: "Reference / UTR",
  paymentDate: "Date",
  mode_cash: "Cash",
  mode_upi: "UPI",
  mode_bank: "Bank Transfer / NEFT",
  mode_card: "Card",
  mode_gold: "Gold",
  mode_advance: "Advance Adjusted",
  mode_cheque: "Cheque",
  mode_outstanding: "Outstanding Credit",
  totalReceived: "Total Received",
  remainingBalance: "Remaining Balance",
  // GST
  gst: "GST",
  gst_none: "No GST",
  gst_3pct: "3% GST (1.5 CGST + 1.5 SGST)",
  gstAmount: "GST Amount",
  gstin: "GSTIN",
  // Totals
  subtotal: "Subtotal",
  grandTotal: "Grand Total",
  advance: "Advance / Adjustment",
  balanceDue: "Balance Due",
  paidAmount: "Paid Amount",
  // Actions
  saveInvoice: "Save & Print",
  saveDraft: "Save Draft",
  printInvoice: "Print Invoice",
  printReceipt: "Print Receipt",
  printEstimate: "Print Estimate",
  emailInvoice: "Email Invoice",
  sendWhatsApp: "WhatsApp",
  deleteInvoice: "Delete Invoice",
  voidInvoice: "Void Invoice",
  // Invoice status
  status_draft: "Draft",
  status_active: "Active",
  status_paid: "Paid",
  status_partial: "Partial",
  status_overdue: "Overdue",
  status_void: "Void",
  // Gold exchange (within billing)
  goldExchange: "Gold Exchange",
  oldGoldReceived: "Old Gold / Exchange",
  customerGoldCredit: "Customer Gold Credit",
  exchangeWeight: "Exchange Weight (g)",
  exchangePurity: "Exchange Purity",
  exchangeRate: "Exchange Rate (₹/g)",
  exchangeValue: "Exchange Value",
  // Keyboard shortcuts
  shortcutScan: "Scan",
  shortcutCustomer: "Customer",
  shortcutOrder: "Order",
  shortcutAddItem: "Add Item",
  shortcutPayment: "Payment",
  shortcutSavePrint: "Save & Print",
  // Messages
  selectCustomerFirst: "Select a customer first.",
  addItemFirst: "Please add at least one line item.",
  itemNeedsName: "Each line item needs a name.",
  itemNeedsDetails: "Each item needs a name, weights, purity and a gold rate.",
  paymentModeRequired: "Payment mode is required for all recorded payments.",
  amountMustBePositive: "Invoice total must be positive.",
  paymentsExceedTotal: "Warning: Recorded payments exceed the invoice total.",
  ownerOverrideRequired: "Owner override or reason required to proceed.",
  invoiceSaved: "Invoice saved successfully.",
  invoiceDeleted: "Invoice deleted.",
  sending: "Sending…",
  emailSent: "Invoice emailed successfully.",
  emailFailed: "Email failed. Check SMTP settings.",
  // Passbook / Ledger
  outstandingCredit: "Outstanding Credit",
  goldSettlement: "Gold Settlement",
  goldSettlementJama: "Jama (Gold In)",
  goldSettlementNaam: "Naam (Gold Out)",
  // Repair inside billing
  repairNo: "Repair No.",
  repairDescription: "Repair Description",
  estimatedWeight: "Estimated Weight",
  // Search / filter
  searchInvoices: "Search by invoice no, customer…",
  filterByStatus: "Filter by status",
  filterByType: "Filter by type",
  dateRange: "Date Range",
  allInvoices: "All Invoices",
  noInvoicesYet: "No invoices yet.",
  createFirstInvoice: "Create the first invoice to get started.",
  // Columns
  col_invoiceNo: "Invoice No.",
  col_date: "Date",
  col_customer: "Customer",
  col_type: "Type",
  col_amount: "Amount",
  col_paid: "Paid",
  col_balance: "Balance",
  col_status: "Status",
  col_action: "Action",
};

export default translations;
